import React from "react";
import pick from "lodash/pick";
import { havePermission } from "../../permissions";
import LAYERS_PERMISSIONS from "../../permissions/Layers.json";
import { selectedPolygonTypes } from "./Constants";
import { Checkbox } from "antd";

const { PopulationGrids, TargetedConsumer } = selectedPolygonTypes;

export const getPopulationColorRanges = (minPop = 0, maxPop = 200000, levels = 5) => {
	// Ensure valid range
	const adjustedMin = Math.max(minPop, 1);
	const adjustedMax = Math.max(maxPop, adjustedMin + 1);

	// Generate step values using logarithmic scale
	const logMin = Math.log(adjustedMin);
	const logMax = Math.log(adjustedMax);
	const step = (logMax - logMin) / levels;

	const ranges = [];

	for (let i = 0; i < levels; i++) {
		const rangeMin = Math.exp(logMin + i * step);
		const rangeMax = Math.exp(logMin + (i + 1) * step);

		ranges.push({
			min: Math.round(rangeMin),
			max: Math.round(rangeMax),
			colorCode: getPopulationColor(rangeMax, minPop, maxPop),
			text: `Population: ${Math.round(rangeMin)} - ${Math.round(rangeMax)}`
		});
	}

	return ranges;
};

export const getPopulationColor = (population, minPop = 0, maxPop = 200000) => {
	// Prevent divide by zero & ensure positive values
	const adjustedMin = Math.max(minPop, 1);
	const adjustedPop = Math.max(population, adjustedMin);
	const adjustedMax = Math.max(maxPop, adjustedPop + 1);

	// Logarithmic normalization
	const logMin = Math.log(adjustedMin);
	const logMax = Math.log(adjustedMax);
	const logPop = Math.log(adjustedPop);

	let ratio = (logPop - logMin) / (logMax - logMin);
	ratio = Math.max(0, Math.min(1, ratio)); // Clamp ratio between 0 and 1

	// Gradient: Light Red (low) → Red (high)
	const startColor = { r: 255, g: 200, b: 200 }; // Light Red
	const endColor = { r: 255, g: 0, b: 0 }; // Red

	const r = Math.round(startColor.r + ratio * (endColor.r - startColor.r));
	const g = Math.round(startColor.g + ratio * (endColor.g - startColor.g));
	const b = Math.round(startColor.b + ratio * (endColor.b - startColor.b));

	return `rgb(${r}, ${g}, ${b})`;
};

const getPopulationGridRange = ({ data }) => {
	let min = Number.MAX_SAFE_INTEGER;
	let max = Number.MIN_SAFE_INTEGER;
	for (let [, obj] of data.entries()) {
		if (obj.population < min) min = obj.population;
		if (obj.population > max) max = obj.population;
	}
	return { min, max };
};

const populationGridsPolygons = ({ locations }) => {
	console.log({ locations });
	let { min, max } = getPopulationGridRange({ data: locations });
	let polygons = [];
	for (let [ind, obj] of locations.entries()) {
		const { population, motor_sports_population, radius_population } = obj;
		polygons.push({
			id: ind,
			_id: ind,
			coordinates: obj.coordinates,
			style: {
				fillColor: getPopulationColor(Number(population), min, max),
				strokeColor: "#00000055",
				zindex: 10
			},
			filterData: {
				population,
				motor_sports_population,
				radius_population
			},
			// showInfo: true,
			polygonClick: true,
			type: PopulationGrids
		});
	}

	return { polygons };
};

const populationGridsLegends = ({ legendHandler }) => {
	let legends = [];
	if (havePermission(LAYERS_PERMISSIONS.LAYER_TRAGETED_CONSUMER))
		legends.push(<Checkbox onClick={() => legendHandler(TargetedConsumer)}>Targeted Consumer</Checkbox>);

	return { legends };
};
const getPopulationGridSlider = ({ locations, dispatch }) => {
	if (!havePermission(LAYERS_PERMISSIONS.LAYER_GRIDS_POPULATION_SLIDER)) return null;

	let { min, max } = getPopulationGridRange({ data: locations });

	const type = PopulationGrids;

	localStorage.setItem(`${type}`, JSON.stringify([min, max]));

	return {
		min,
		max,
		sliderHandler: value => {
			dispatch({ type: "filterPolygons", value: { value, type: `${PopulationGrids}` } });
		},
		type
	};
};

const PopulationGrid = {
	all: ({ locations, filter, range, type, sliderHandler, legendHandler, dispatch }) => {
		return {
			...pick(populationGridsPolygons({ locations, range, filter, type }), ["polygons"]),
			...{ slider: getPopulationGridSlider({ sliderHandler, locations, type, dispatch }) },
			...populationGridsLegends({ locations, legendHandler, topAttribute: "" })
		};
	},
	polygons: ({ locations, range, filter }) => {
		return {
			...pick(populationGridsPolygons({ locations, range, filter }), ["polygons"])
		};
	}
};
export default PopulationGrid;

export { populationGridsPolygons, getPopulationGridSlider, getPopulationGridRange };
